import { render } from "./Tablet.vue?vue&type=template&id=4a707dcb&scoped=true"
import script from "./Tablet.vue?vue&type=script&lang=js"
export * from "./Tablet.vue?vue&type=script&lang=js"

import "./Tablet.vue?vue&type=style&index=0&id=4a707dcb&lang=css&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a707dcb"]])

export default __exports__